<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a href="#/dashboard">
        <span>
          {{ $t("Dashboard") }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    avatar: {
      type: String,
      default: "./img/Dashboard.png"
    }
  },
  data() {
    return {
      isClosed: false
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
